import {
  Box,
  Divider,
  Grid,
  MenuItem,
  TextField,
  Toolbar,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import ImageWithDeleteButton from "../../Update_Campaign/comman/imageContainer";
import { Button } from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { uploadImage } from "../../../redux/actions/addCampaigndata";
import {
  footerAi,
  getBodyData,
  updateFooterAi,
} from "../../../redux/actions/ai_functions";
import {
  Add,
  Delete,
  ExpandLess,
  ExpandMore,
  StarRate,
} from "@mui/icons-material";
import InputFieldOrder from "./aiSaasInputFieldOrderFooter";
// import { uploadImage } from "../../../redux/actions/addCampaigndata";

const CreateAiFooter = ({
  handleNext,
  validationFooterSchema,
  activeStep,
  setActiveStep,
  handleCloseDialog,
  setManualStepChange,
  manualStepChange,
}) => {
  const [updatingAgentId, setUpdatingAgentId] = useState();
  const [footerLogoCollapsed, setFooterLogoCollapsed] = useState(true);
  const [socialMediaCollapsed, setSocialMediaCollapsed] = useState(true);
  const [customerSupportCollapsed, setCustomerSupportCollapsed] =
    useState(true);
  const [brandPartnersCollapsed, setBrandPartnersCollapsed] = useState(true);
  const [quickLinksCollapsed, setQuickLinksCollapsed] = useState(true);
  const [bankPartnersCollapsed, setBankPartnersCollapsed] = useState(true);
  const [footerImagesCollapsed, setFooterImagesCollapsed] = useState(true);
  const {
    createAiFooterData,
    footerDataForParticular,
    updatedAiFooterData,
    headerDataForParticular,
    ongoing_ai_id,
  } = useSelector((state) => state?.aiDataReducer);
  const {
    formState: { errors },
    control,
    handleSubmit,
    watch,
    clearErrors,
    setValue,
    setError,
    register,
  } = useForm({
    resolver: yupResolver(validationFooterSchema),
    defaultValues: {
      footer_logo: {
        logo: null,
        link: "",
      },
      social_media: footerDataForParticular?.social_media || [
        {
          logo: null,
          link: "",
          target: "_self",
          alt: "",
          order: null,
        },
      ],
      customer_support: footerDataForParticular?.customer_support || [
        {
          text: "",
          value: "",
          order: null,
          link: "",
        },
      ],
      brand_partners: footerDataForParticular?.brand_partners || [
        {
          text: "",
          link: "",
          target: "_self",
          order: null,
        },
      ],
      quick_links: footerDataForParticular?.quick_links || [{ text: "", link: "", target: "_self", order: null }],
      bank_partners: footerDataForParticular?.bank_partners || [
        {
          text: "",
          link: "",
          target: "_self",
          order: null,
        },
      ],
      footer_images: footerDataForParticular?.footer_images || [
        {
          image: null,
          link: "",
          target: "",
          alt: "",
          order: null,
        },
      ],
      agent_id: "",
      copy_right: "",
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "social_media",
  });

  const {
    fields: customerSupport,
    append: customerSupportAppend,
    remove: customerSupportRemove,
  } = useFieldArray({
    control,
    name: "customer_support",
  });

  const {
    fields: footerImages,
    append: footerImagesAppend,
    remove: footerImagesRemove,
  } = useFieldArray({
    control,
    name: "footer_images",
  });

  const {
    fields: brandPartners,
    append: brandPartnersAppend,
    remove: brandPartnersRemove,
  } = useFieldArray({
    control,
    name: "brand_partners",
  });

  const {
    fields: bankPartners,
    append: bankPartnersAppend,
    remove: bankPartnersRemove,
  } = useFieldArray({
    control,
    name: "bank_partners",
  });
  const {
    fields: quickLinks,
    append: quickLinksAppend,
    remove: quickLinksRemove,
  } = useFieldArray({
    control,
    name: "quick_links",
  });

  const dispatch = useDispatch();

  const handleImage = async (logo, e) => {
    const file = e.target.files[0];
    if (!file || !file.type.startsWith("image/")) {
      setError(`${logo}.file`, {
        type: "manual",
        message: "Invalid file type. Please select a valid image.",
      });
      return;
    }

    clearErrors(`${logo}.file`);
    const formData = new FormData();
    formData.append("image", file);

    try {
      const res = await dispatch(uploadImage(formData));
      setValue(`${logo}.image`, res);
    } catch (err) {
      console.error(err);
    }
  };

  const handleLogo = async (logo, e) => {
    const file = e.target.files[0];
    if (!file || !file.type.startsWith("image/")) {
      setError(`${logo}.file`, {
        type: "manual",
        message: "Invalid file type. Please select a valid image.",
      });
      return;
    }

    clearErrors(`${logo}.file`);
    const formData = new FormData();
    formData.append("image", file);

    try {
      const res = await dispatch(uploadImage(formData));
      setValue(`${logo}.logo`, res);
    } catch (err) {
      console.error(err);
    }
  };

  console.log("errors", errors);

  const onSubmit = (data) => {
    try {
      const {
        footer_logo,
        footer_images,
        social_media,
        brand_partners,
        bank_partners,
        quick_links,
        customer_support,
        copy_right,
        agent_id,
      } = data;
      const recreatedSchema = {
        footer_logo,
        footer_images,
        social_media,
        brand_partners,
        bank_partners,
        quick_links,
        customer_support,
        copy_right,
        agent_id,
        created_by: localStorage.getItem("userID"),
      };

      if (footerDataForParticular?.created_by) {
        dispatch(updateFooterAi(recreatedSchema));
      } else {
        dispatch(footerAi(recreatedSchema));
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("updatingAgentId")) {
      setUpdatingAgentId(localStorage.getItem("updatingAgentId"));
    }
  }, []);

  useEffect(() => {
    if (updatedAiFooterData && localStorage.getItem("isFooterUpdated")) {
      handleNext();
      localStorage.removeItem("isFooterUpdated");
    }
  }, [updatedAiFooterData]);

  useEffect(() => {
    if (createAiFooterData && localStorage.getItem("isFooterCreated")) {
      handleNext();
      localStorage.removeItem("isFooterCreated");
    }
  }, [createAiFooterData]);

  useEffect(() => {
    setValue("agent_id", headerDataForParticular?.agent_id || ongoing_ai_id);
    setValue("copy_right", footerDataForParticular?.copy_right);
    setValue("footer_logo.logo", footerDataForParticular?.footer_logo?.logo);
    setValue("footer_logo.link", footerDataForParticular?.footer_logo?.link);

    footerDataForParticular?.social_media?.forEach((item, index) => {
      if (item) {
        // Create an object to hold non-empty fields
        const fieldsToSet = {};

        if (item.logo) fieldsToSet[`social_media[${index}].logo`] = item.logo;
        if (item.alt) fieldsToSet[`social_media[${index}].alt`] = item.alt;
        if (item.link) fieldsToSet[`social_media[${index}].link`] = item.link;
        if (item.order)
          fieldsToSet[`social_media[${index}].order`] = item.order;
        if (item.target)
          fieldsToSet[`social_media[${index}].target`] = item.target;

        // Set the values only for non-empty fields
        Object.entries(fieldsToSet).forEach(([key, value]) =>
          setValue(key, value)
        );
      }
    });
    footerDataForParticular?.footer_images?.forEach((item, index) => {
      if (item) {
        // Create an object to hold non-empty fields
        const fieldsToSet = {};

        if (item?.image)
          fieldsToSet[`footer_images[${index}].image`] = item?.image;
        if (item?.alt) fieldsToSet[`footer_images[${index}].alt`] = item?.alt;
        if (item?.link) fieldsToSet[`footer_images[${index}].link`] = item?.link;
        if (item?.order)
          fieldsToSet[`footer_images[${index}].order`] = item?.order;
        if (item?.target)
          fieldsToSet[`footer_images[${index}].target`] = item?.target;

        // Set the values only for non-empty fields
        Object?.entries(fieldsToSet)?.forEach(([key, value]) =>
          setValue(key, value)
        );
      }
    });
    footerDataForParticular?.brand_partners?.forEach((item, index) => {
      if (item) {
        // Create an object to hold non-empty fields
        const fieldsToSet = {};

        if (item?.text) fieldsToSet[`brand_partners[${index}].text`] = item?.text;
        if (item?.link) fieldsToSet[`brand_partners[${index}].link`] = item?.link;
        if (item?.order)
          fieldsToSet[`brand_partners[${index}].order`] = item?.order;
        if (item?.target)
          fieldsToSet[`brand_partners[${index}].target`] = item?.target;

        // Set the values only for non-empty fields
        Object.entries(fieldsToSet).forEach(([key, value]) =>
          setValue(key, value)
        );
      }
    });
    footerDataForParticular?.bank_partners?.forEach((item, index) => {
      if (item) {
        // Create an object to hold non-empty fields
        const fieldsToSet = {};

        if (item?.text) fieldsToSet[`bank_partners[${index}].text`] = item?.text;
        if (item?.link) fieldsToSet[`bank_partners[${index}].link`] = item?.link;
        if (item?.order)
          fieldsToSet[`bank_partners[${index}].order`] = item?.order;
        if (item?.target)
          fieldsToSet[`bank_partners[${index}].target`] = item?.target;

        // Set the values only for non-empty fields
        Object?.entries(fieldsToSet)?.forEach(([key, value]) =>
          setValue(key, value)
        );
      }
    });
    footerDataForParticular?.quick_links?.forEach((item, index) => {
      if (item) {
        // Create an object to hold non-empty fields
        const fieldsToSet = {};

        if (item?.text) fieldsToSet[`quick_links[${index}].text`] = item?.text;
        if (item?.link) fieldsToSet[`quick_links[${index}].link`] = item?.link;
        if (item?.order) fieldsToSet[`quick_links[${index}].order`] = item?.order;
        if (item?.target)
          fieldsToSet[`quick_links[${index}].target`] = item?.target;

        // Set the values only for non-empty fields
        Object?.entries(fieldsToSet)?.forEach(([key, value]) =>
          setValue(key, value)
        );
      }
    });
    footerDataForParticular?.customer_support?.forEach((item, index) => {
      if (item) {
        // Create an object to hold non-empty fields
        const fieldsToSet = {};

        if (item?.text)
          fieldsToSet[`customer_support[${index}].text`] = item?.text;
        if (item?.link)
          fieldsToSet[`customer_support[${index}].link`] = item?.link;
        if (item?.order)
          fieldsToSet[`customer_support[${index}].order`] = item?.order;
        if (item?.value)
          fieldsToSet[`customer_support[${index}].value`] = item?.value;

        // Set the values only for non-empty fields
        Object?.entries(fieldsToSet)?.forEach(([key, value]) =>
          setValue(key, value)
        );
      }
    });
  }, [footerDataForParticular, setValue]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2} sx={{ paddingY: "2rem",display:"flex",justifyContent:"space-around" }}>
          <Grid item xs={12} md={5}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "10px",
                border: footerLogoCollapsed ? "" : "1px solid green",
                borderRadius: "10px",
                gap: "10px",
              }}
            >
              <div
                style={{
                  border: errors?.footer_logo
                    ? "2px solid red"
                    : "2px solid green",
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  padding: "8px",
                  margin: "0px auto",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (footerLogoCollapsed) {
                    setFooterLogoCollapsed(false);
                  } else {
                    setFooterLogoCollapsed(true);
                  }
                }}
              >
                <StarRate className="text-success" />
                <span>Footer Logo</span>
                {footerLogoCollapsed ? (
                  <ExpandLess className="text-success" />
                ) : (
                  <ExpandMore className="text-success" />
                )}
              </div>
              <div
                style={{
                  display: footerLogoCollapsed ? "none" : "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Button
                    variant="contained"
                    component="label"
                    color={errors?.footer_logo?.logo ? "error" : "success"}
                    style={{ height: "fit-content", width: "fit-content" }}
                  >
                    Logo
                    <input
                      type="file"
                      hidden
                      onChange={(e) => {
                        handleLogo("footer_logo", e);
                        clearErrors("footer_logo.logo");
                      }}
                    />
                  </Button>

                  <ImageWithDeleteButton
                    logoName="footer_logo.logo"
                    watch={watch}
                    setValue={setValue}
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    gap: "10px",
                  }}
                >
                  <Controller
                    name="footer_logo.link"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        label="Link"
                        {...field}
                        error={!!errors.footer_logo?.link}
                        helperText={errors.footer_logo?.link?.message || ""}
                        margin="normal"
                        className="w-100"
                      />
                    )}
                  />
                </Box>
              </div>
            </div>
            <Divider className="m-3 bg-success" />

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "10px",
                border: brandPartnersCollapsed ? "" : "1px solid green",
                borderRadius: "10px",
                gap: "10px",
              }}
            >
              <div
                style={{
                  border: errors?.brand_partners
                    ? "2px solid red"
                    : "2px solid green",
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  padding: "8px",
                  margin: "0px auto",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (brandPartnersCollapsed) {
                    setBrandPartnersCollapsed(false);
                  } else {
                    setBrandPartnersCollapsed(true);
                  }
                }}
              >
                <StarRate className="text-success" />
                <span>Brand Partners</span>
                {brandPartnersCollapsed ? (
                  <ExpandLess className="text-success" />
                ) : (
                  <ExpandMore className="text-success" />
                )}
              </div>
              <div
                style={{
                  display: brandPartnersCollapsed ? "none" : "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <InputFieldOrder
                  fieldName={`brand_partners`}
                  appendfunc={brandPartnersAppend}
                  remove={brandPartnersRemove}
                  fieldsArray={brandPartners}
                  watch={watch}
                  register={register}
                  setValue={setValue}
                  control={control}
                  errors={errors}
                />
              </div>
            </div>
            <Divider className="m-3 bg-success" />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "10px",
                border: bankPartnersCollapsed ? "" : "1px solid green",
                borderRadius: "10px",
                gap: "10px",
              }}
            >
              <div
                style={{
                  border: errors?.bank_partners
                    ? "2px solid red"
                    : "2px solid green",
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  padding: "8px",
                  margin: "0px auto",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (bankPartnersCollapsed) {
                    setBankPartnersCollapsed(false);
                  } else {
                    setBankPartnersCollapsed(true);
                  }
                }}
              >
                <StarRate className="text-success" />
                <span>Bank Partners</span>
                {bankPartnersCollapsed ? (
                  <ExpandLess className="text-success" />
                ) : (
                  <ExpandMore className="text-success" />
                )}
              </div>
              <div
                style={{
                  display: bankPartnersCollapsed ? "none" : "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <InputFieldOrder
                  fieldName={`bank_partners`}
                  appendfunc={bankPartnersAppend}
                  remove={bankPartnersRemove}
                  fieldsArray={bankPartners}
                  watch={watch}
                  register={register}
                  setValue={setValue}
                  control={control}
                  errors={errors}
                />
              </div>
            </div>
            <Divider className="m-3 bg-success" />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "10px",
                border: quickLinksCollapsed ? "" : "1px solid green",
                borderRadius: "10px",
                gap: "10px",
              }}
            >
              <div
                style={{
                  border: errors?.quick_links
                    ? "2px solid red"
                    : "2px solid green",
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  padding: "8px",
                  margin: "0px auto",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (quickLinksCollapsed) {
                    setQuickLinksCollapsed(false);
                  } else {
                    setQuickLinksCollapsed(true);
                  }
                }}
              >
                <StarRate className="text-success" />
                <span>Quick Links</span>
                {quickLinksCollapsed ? (
                  <ExpandLess className="text-success" />
                ) : (
                  <ExpandMore className="text-success" />
                )}
              </div>
              <div
                style={{
                  display: quickLinksCollapsed ? "none" : "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <InputFieldOrder
                  fieldName={`quick_links`}
                  appendfunc={quickLinksAppend}
                  remove={quickLinksRemove}
                  fieldsArray={quickLinks}
                  watch={watch}
                  register={register}
                  setValue={setValue}
                  control={control}
                  errors={errors}
                />
              </div>
            </div>
            <Divider className="m-3 bg-success" />
          </Grid>
          <Grid item xs={12} md={5}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "10px",
                border: socialMediaCollapsed ? "" : "1px solid green",
                borderRadius: "10px",
                gap: "10px",
              }}
            >
              <div
                style={{
                  border: errors?.social_media
                    ? "2px solid red"
                    : "2px solid green",
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  padding: "8px",
                  margin: "0px auto",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (socialMediaCollapsed) {
                    setSocialMediaCollapsed(false);
                  } else {
                    setSocialMediaCollapsed(true);
                  }
                }}
              >
                <StarRate className="text-success" />
                <span>Social Media</span>
                {socialMediaCollapsed ? (
                  <ExpandLess className="text-success" />
                ) : (
                  <ExpandMore className="text-success" />
                )}
              </div>
              <div
                style={{
                  display: socialMediaCollapsed ? "none" : "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                {fields?.map((item, index) => (
                  <div
                    style={{ display: "flex", flexDirection: "column" }}
                    key={item.id}
                  >
                    <div>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Button
                          variant="contained"
                          component="label"
                          color={
                            errors.social_media &&
                            errors?.social_media[index]?.logo
                              ? "error"
                              : "success"
                          }
                          style={{ height: "fit-content" }}
                        >
                          Social Media Logo
                          <input
                            type="file"
                            hidden
                            onChange={(e) => {
                              handleLogo(`social_media[${index}]`, e);
                              clearErrors(`social_media[${index}].logo`);
                            }}
                          />
                        </Button>
                        <ImageWithDeleteButton
                          logoName={`social_media[${index}].logo`}
                          watch={watch}
                          setValue={setValue}
                        />
                      </Box>
                    </div>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: "20px",
                      }}
                    >
                      <Controller
                        name={`social_media[${index}].alt`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Text"
                            margin="normal"
                            className="w-50"
                            error={
                              errors.social_media &&
                              errors?.social_media[index]?.alt
                            }
                            helperText={
                              (errors?.social_media &&
                                errors.social_media[index]?.alt?.message) ||
                              ""
                            }
                          />
                        )}
                      />
                      <Controller
                        name={`social_media[${index}].link`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            label="Link"
                            {...field}
                            error={
                              errors.social_media &&
                              errors.social_media[index]?.link
                            }
                            helperText={
                              (errors.social_media &&
                                errors.social_media[index]?.link?.message) ||
                              ""
                            }
                            margin="normal"
                            className="w-50"
                          />
                        )}
                      />
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: "20px",
                      }}
                    >
                      <Controller
                        name={`social_media[${index}].target`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Target"
                            select
                            margin="normal"
                            className="w-50"
                            error={
                              errors.social_media &&
                              errors.social_media[index]?.target
                            }
                            helperText={
                              (errors.social_media &&
                                errors.social_media[index]?.target?.message) ||
                              ""
                            }
                          >
                            <MenuItem value="_self">_self</MenuItem>
                            <MenuItem value="_blank">_blank</MenuItem>
                          </TextField>
                        )}
                      />
                      <Controller
                        name={`social_media[${index}].order`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            type="number"
                            select
                            label="Order"
                            value={field.value || ""}
                            margin="normal"
                            className="w-50"
                            error={
                              errors.social_media &&
                              errors.social_media[index]?.order
                            }
                            helperText={
                              (errors.social_media &&
                                errors.social_media[index]?.order?.message) ||
                              ""
                            }
                          >
                            {[...Array(15).keys()].map((number) => (
                              <MenuItem
                                key={number + 1}
                                value={(number + 1).toString()}
                              >
                                {number + 1}
                              </MenuItem>
                            ))}
                          </TextField>
                        )}
                      />
                    </Box>
                    <div className="column d-flex justify-content-end m-2">
                      {fields.length > 1 && (
                        <Tooltip title="Delete" arrow>
                          <Delete
                            onClick={() => remove(index)}
                            style={{ color: "red", cursor: "pointer" }}
                          />
                        </Tooltip>
                      )}
                    </div>
                  </div>
                ))}
                <Toolbar className="p-0">
                  <Tooltip title="Add" arrow>
                    <Button
                      className="button "
                      variant="outlined"
                      disableElevation
                      startIcon={<Add />}
                      onClick={(e) => {
                        e.preventDefault();
                        append({
                          logo: null,
                          text: "",
                          link: "",
                          target: "",
                          order: null,
                        });
                      }}
                    >
                      Add
                    </Button>
                  </Tooltip>
                </Toolbar>
              </div>
            </div>
            <Divider className="m-3 bg-success" />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                borderRadius: "10px",
                gap: "10px",
                padding: "10px",
                border: footerImagesCollapsed ? "" : "1px solid green",
              }}
            >
              <div
                style={{
                  border: errors?.footer_images
                    ? "2px solid red"
                    : "2px solid green",
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  padding: "8px",
                  margin: "0px auto",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (footerImagesCollapsed) {
                    setFooterImagesCollapsed(false);
                  } else {
                    setFooterImagesCollapsed(true);
                  }
                }}
              >
                <StarRate className="text-success" />
                <span>Footer Images</span>
                {footerImagesCollapsed ? (
                  <ExpandLess className="text-success" />
                ) : (
                  <ExpandMore className="text-success" />
                )}
              </div>
              <div
                style={{
                  display: footerImagesCollapsed ? "none" : "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                {footerImages?.map((item, index) => (
                  <div
                    style={{ display: "flex", flexDirection: "column" }}
                    key={item.id}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Button
                        variant="contained"
                        component="label"
                        color={
                          errors.footer_images &&
                          errors?.footer_images[index]?.image
                            ? "error"
                            : "success"
                        }
                        style={{ height: "fit-content" }}
                      >
                        Footer Image
                        <input
                          type="file"
                          hidden
                          onChange={(e) => {
                            handleImage(`footer_images[${index}]`, e);
                            clearErrors(`footer_images[${index}].image`);
                          }}
                        />
                      </Button>
                      <ImageWithDeleteButton
                        logoName={`footer_images[${index}].image`}
                        watch={watch}
                        setValue={setValue}
                      />
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: "20px",
                      }}
                    >
                      <Controller
                        name={`footer_images[${index}].alt`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Alt text"
                            margin="normal"
                            className="w-50"
                            error={!!errors.footer_images?.[index]?.alt}
                            helperText={
                              errors.footer_images?.[index]?.alt?.message || ""
                            }
                          />
                        )}
                      />
                      <Controller
                        name={`footer_images[${index}].link`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            label="Link"
                            {...field}
                            error={!!errors.footer_images?.[index]?.link}
                            helperText={
                              errors.footer_images?.[index]?.link?.message || ""
                            }
                            margin="normal"
                            className="w-50"
                          />
                        )}
                      />
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: "20px",
                      }}
                    >
                      <Controller
                        name={`footer_images[${index}].target`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Target"
                            select
                            margin="normal"
                            className="w-50"
                            error={!!errors.footer_images?.[index]?.target}
                            helperText={
                              errors.footer_images?.[index]?.target?.message ||
                              ""
                            }
                          >
                            <MenuItem value="_self">_self</MenuItem>
                            <MenuItem value="_blank">_blank</MenuItem>
                          </TextField>
                        )}
                      />
                      <Controller
                        name={`footer_images[${index}].order`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            type="number"
                            select
                            label="Order"
                            value={field.value || ""}

                            margin="normal"
                            className="w-50"
                            error={
                              errors.footer_images &&
                              errors.footer_images[index]?.order
                            }
                            helperText={
                              (errors.footer_images &&
                                errors.footer_images[index]?.order?.message) ||
                              ""
                            }
                          >
                            {[...Array(15).keys()].map((number) => (
                              <MenuItem
                                key={number + 1}
                                value={(number + 1).toString()}
                              >
                                {number + 1}
                              </MenuItem>
                            ))}
                          </TextField>
                        )}
                      />
                    </Box>
                    <div className="column d-flex justify-content-end m-2">
                      {fields.length > 0 && (
                        <Tooltip title="Delete" arrow>
                          <Delete
                            onClick={() => footerImagesRemove(index)}
                            style={{ color: "red", cursor: "pointer" }}
                          />
                        </Tooltip>
                      )}
                    </div>
                  </div>
                ))}
                <Toolbar className="p-0">
                  <Tooltip title="Add" arrow>
                    <Button
                      className="button "
                      variant="outlined"
                      disableElevation
                      startIcon={<Add />}
                      onClick={(e) => {
                        e.preventDefault();
                        footerImagesAppend({
                          image: null,
                          alt: "",
                          link: "",
                          target: "",
                          order: null,
                        });
                      }}
                    >
                      Add
                    </Button>
                  </Tooltip>
                </Toolbar>
              </div>
            </div>
            <Divider className="m-3 bg-success" />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                padding: "10px",
                border: customerSupportCollapsed ? "" : "1px solid green",
                borderRadius: "10px",
                gap: "10px",
              }}
            >
              <div
                className="w-100 text-center"
                style={{
                  border: errors?.customer_support
                    ? "2px solid red"
                    : "2px solid green",
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  padding: "8px",
                  margin: "0px auto",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (customerSupportCollapsed) {
                    setCustomerSupportCollapsed(false);
                  } else {
                    setCustomerSupportCollapsed(true);
                  }
                }}
              >
                <StarRate className="text-success" />
                <span>Customer Support</span>
                {customerSupportCollapsed ? (
                  <ExpandLess className="text-success" />
                ) : (
                  <ExpandMore className="text-success" />
                )}
              </div>
              <div
                style={{
                  display: customerSupportCollapsed ? "none" : "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                {customerSupport?.map((item, index) => (
                  <div
                    style={{ display: "flex", flexDirection: "column" }}
                    key={item.id}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: "20px",
                      }}
                    >
                      <Controller
                        name={`customer_support[${index}].text`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Text"
                            margin="normal"
                            className="w-50"
                            error={
                              errors.customer_support &&
                              errors?.customer_support[index]?.text
                            }
                            helperText={
                              (errors?.customer_support &&
                                errors.customer_support[index]?.text
                                  ?.message) ||
                              ""
                            }
                          />
                        )}
                      />
                      <Controller
                        name={`customer_support[${index}].value`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Value"
                            margin="normal"
                            className="w-50"
                            error={
                              errors.customer_support &&
                              errors?.customer_support[index]?.value
                            }
                            helperText={
                              (errors?.customer_support &&
                                errors.customer_support[index]?.value
                                  ?.message) ||
                              ""
                            }
                          />
                        )}
                      />
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: "20px",
                      }}
                    >
                      <Controller
                        name={`customer_support[${index}].link`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            label="Link"
                            {...field}
                            error={
                              errors.customer_support &&
                              errors.customer_support[index]?.link
                            }
                            helperText={
                              (errors.customer_support &&
                                errors.customer_support[index]?.link
                                  ?.message) ||
                              ""
                            }
                            margin="normal"
                            className="w-50"
                          />
                        )}
                      />
                      <Controller
                        name={`customer_support[${index}].order`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            type="number"
                            select
                            label="Order"
                            value={field.value || ""}
                            margin="normal"
                            className="w-50"
                            error={
                              errors.customer_support &&
                              errors.customer_support[index]?.order
                            }
                            helperText={
                              (errors.customer_support &&
                                errors.customer_support[index]?.order
                                  ?.message) ||
                              ""
                            }
                          >
                            {[...Array(15).keys()].map((number) => (
                              <MenuItem
                                key={number + 1}
                                value={(number + 1).toString()}
                              >
                                {number + 1}
                              </MenuItem>
                            ))}
                          </TextField>
                        )}
                      />
                    </Box>

                    <div className="column d-flex justify-content-end m-2">
                      {fields.length > 0 && (
                        <Tooltip title="Delete" arrow>
                          <Delete
                            onClick={() => customerSupportRemove(index)}
                            style={{ color: "red", cursor: "pointer" }}
                          />
                        </Tooltip>
                      )}
                    </div>
                  </div>
                ))}
                <Toolbar className="p-0">
                  <Tooltip title="Add" arrow>
                    <Button
                      className="button "
                      variant="outlined"
                      disableElevation
                      startIcon={<Add />}
                      onClick={(e) => {
                        e.preventDefault();
                        customerSupportAppend({
                          text: "",
                          link: "",
                          target: "",
                          order: null,
                        });
                      }}
                    >
                      Add
                    </Button>
                  </Tooltip>
                </Toolbar>
              </div>
            </div>
            <Divider className="m-3 bg-success" />
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: "20px",
                paddingX:"10px"
              }}
            >
              <Controller
                name="copy_right"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Copyright"
                    margin="normal"
                    className="w-50"
                    error={errors.copy_right && errors?.copy_right}
                    helperText={
                      (errors?.copy_right && errors.copy_right?.message) || ""
                    }
                  />
                )}
              />{" "}
              <Controller
                name="agent_id"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Agent Id"
                    InputProps={{
                      readOnly: true,
                    }}
                    margin="normal"
                    className="w-50"
                    error={errors.agent_id && errors?.agent_id}
                    helperText={
                      (errors?.agent_id && errors.agent_id?.message) || ""
                    }
                  />
                )}
              />{" "}
            </Box>
          </Grid>
        </Grid>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            onClick={() => {
              if (activeStep >= 1) {
                setManualStepChange(true);
                setActiveStep((prev) => prev - 1);
                if (ongoing_ai_id) {
                  const data = {
                    agent_id: ongoing_ai_id,
                    name: "body",
                  };
                  dispatch(getBodyData(data));
                } else {
                  const data = {
                    agent_id: updatingAgentId,
                    name: "body",
                  };
                  dispatch(getBodyData(data));
                }
              }
            }}
          >
            Previous
          </Button>
          <Button variant="contained" type="submit">
            Finish
          </Button>
        </Box>
      </form>
    </>
  );
};

export default CreateAiFooter;
